import React, { useEffect, useRef, useState } from "react";
import Cookies from "js-cookie";
import { useDispatch } from "react-redux";
import { NotificationIcon } from "assets/images";
import {
    CustomLogOut,
    CustomTabsIcon,
    CustomTabsSettingsIcon,
    Icon,
    IconWrapper,
    RightIcons,
    RightWrapper,
    VirtButton,
} from "./sideMenuStyles";
import { logOut } from "store/reducers/AuthSlice";
import TabsSideDropdown from "components/SideDrop/TabsSideDropdown/TabsSideDropdown";
import TabsLayoutDropdown from "components/SideDrop/TabsLayoutDropdown/TabsLayoutDropdown";

import { useAppSelector } from "../../hooks/redux";

import {
    resetTabsState,
    sendTickerCommand,
} from "../../store/reducers/TabsSlice";
import { resetQuotesPageState } from "../../store/reducers/QuotesPageReducer";

import { resetQuotesState } from "../../store/reducers/quotes";
import {
    // changeTickerBlockStatus,
    resetState,
    setShowDescriptions,
} from "../../store/reducers/SettingsSlice";
import { pathname } from "store/reducers/ActionCreators";
import NotificationModal from "components/NotificationMadal/NotificationModal";
import Settings from "./Settings";
import CustomBadge from "components/CustomBadge/CustomBadge";
import { fetchUsers } from "store/reducers/userSlice";
import LogsWebSocket from "./LogsWebSocket";
import { Switch } from "antd";
import MassCommandsDropdown from "components/MassCommandsDropdown";
import EditModeToggle from "./EditMode";
import { getFilterTickers } from "store/reducers/FilterSlice";

const server_pathname = pathname.slice();

interface IProps {
    pathname: string;
}

const RightSideMenu = ({ pathname }: IProps) => {
    const dispatch = useDispatch();
    const [isTabsSelectOpened, setIsTabsSelectOpened] = useState(false);
    const [isTabsLayoutOpened, setIsTabsLayoutOpened] = useState(false);

    const { totalUnread } = useAppSelector((state) => state.notifications);
    const [selectedIconName, setSelectedIconName] = useState<
        "Select" | "Layout" | "" | "Drag"
    >("");

    const { activeGroup, activeTicker, showDescriptions } = useAppSelector(
        (state) => state.settings,
    );

    const tabsListWrapper = useRef<HTMLDivElement>(null);
    const settingsWrapper = useRef<HTMLDivElement>(null);

    const tabRef = useRef<HTMLDivElement>(null);
    const tabSettingsRef = useRef<HTMLDivElement>(null);
    // const dragRef = useRef<HTMLDivElement>(null)
    const [isNotificationModalOpen, setIsNotificationModalOpen] =
        useState(false);

    const unblockTickerOnLeave = (body: any) => {
        fetch(`${server_pathname}/api/unblock`, {
            method: "POST",
            headers: {
                Authorization: `Bearer ${Cookies.get("access")}`,
                "Content-Type": "application/json",
            },
            body: JSON.stringify(body),
        });
    };

    const handleLogOutClick = async () => {
        if (activeTicker.name.length) {
            unblockTickerOnLeave({
                blockIt: false,
                group_name: activeGroup.name,
                ticker_name: activeTicker.name,
            });
        }

        Cookies.remove("access");
        Cookies.remove("activePageId");

        dispatch(logOut());
        dispatch(resetTabsState());
        dispatch(resetQuotesPageState());
        dispatch(resetQuotesState());

        const timeout = setTimeout(() => {
            dispatch(resetState());
            clearTimeout(timeout);
        }, 50);
    };

    const handleTabsSelectIconClick = (type: "close" | "open") => () => {
        if (type === "open") {
            setIsTabsSelectOpened(true);
            setSelectedIconName("Select");
        } else if (type === "close") {
            setIsTabsSelectOpened(false);
            setSelectedIconName("");
        }
    };

    const handleTabsLayoutIconClick = (type: "open" | "close") => () => {
        if (type === "open") {
            setIsTabsLayoutOpened(true);
            setSelectedIconName("Layout");
        } else if (type === "close") {
            setIsTabsLayoutOpened(false);
            setSelectedIconName("");
        }
    };
    const openNotificationModal = () => setIsNotificationModalOpen(true);
    const closeNotificationModal = () => setIsNotificationModalOpen(false);

    const [currenPage, setCurrentPage] = useState<{
        changes: number;
        system: number;
        web_alerts: number;
    }>({
        changes: 1,
        system: 1,
        web_alerts: 1,
    });
    const currenPageRef = useRef(currenPage);

    useEffect(() => {
        currenPageRef.current = currenPage;
    }, [currenPage]);

    useEffect(() => {
        dispatch(fetchUsers());

        dispatch(getFilterTickers());
    }, [dispatch]);

    return (
        <>
            <RightWrapper>
                <RightIcons>
                    <IconWrapper>
                        <Icon onClick={handleLogOutClick}>
                            <CustomLogOut />
                        </Icon>
                    </IconWrapper>
                    {pathname === "/quotes" && (
                        <>
                            <IconWrapper ref={tabsListWrapper}>
                                <Icon
                                    ref={tabRef}
                                    onClick={
                                        !isTabsSelectOpened
                                            ? handleTabsSelectIconClick("open")
                                            : handleTabsSelectIconClick("close")
                                    }
                                    className={
                                        selectedIconName === "Select"
                                            ? "selected"
                                            : ""
                                    }
                                >
                                    <CustomTabsIcon />
                                </Icon>
                                {isTabsSelectOpened && (
                                    <TabsSideDropdown
                                        isOpen={isTabsSelectOpened}
                                        ref={tabRef}
                                        wrapperRef={tabsListWrapper}
                                        closeHandler={handleTabsSelectIconClick(
                                            "close",
                                        )}
                                    />
                                )}
                            </IconWrapper>
                            <IconWrapper ref={settingsWrapper}>
                                <Icon
                                    ref={tabSettingsRef}
                                    onClick={
                                        !isTabsLayoutOpened
                                            ? handleTabsLayoutIconClick("open")
                                            : handleTabsLayoutIconClick("close")
                                    }
                                    className={
                                        selectedIconName === "Layout"
                                            ? "selected"
                                            : ""
                                    }
                                >
                                    <CustomTabsSettingsIcon />
                                </Icon>
                                {isTabsLayoutOpened && (
                                    <TabsLayoutDropdown
                                        isOpen={isTabsLayoutOpened}
                                        ref={tabSettingsRef}
                                        wrapperRef={settingsWrapper}
                                        closeHandler={handleTabsLayoutIconClick(
                                            "close",
                                        )}
                                    />
                                )}
                            </IconWrapper>
                        </>
                    )}
                    {
                        <IconWrapper
                            style={{
                                display: "flex",
                                justifyContent: "center",
                                alignItems: "center",
                                paddingTop: "8px",
                            }}
                        >
                            <CustomBadge count={totalUnread} overflowCount={99}>
                                <span
                                    style={{
                                        fontSize: "18px",
                                        cursor: "pointer",
                                    }}
                                    onClick={openNotificationModal}
                                >
                                    <NotificationIcon />
                                </span>
                            </CustomBadge>
                        </IconWrapper>
                    }
                    {/* {pathname === "/settings" && <Settings />} */}
                    {pathname === "/settings" && (
                        <div style={{ padding: "0 2px", marginBottom: "4px" }}>
                            <p style={{ fontSize: "8px" }}>Подсказки</p>
                            <Switch
                                checked={showDescriptions}
                                onChange={(checked) =>
                                    dispatch(setShowDescriptions(checked))
                                }
                                style={{
                                    backgroundColor: showDescriptions
                                        ? "rgb(124, 190, 123)"
                                        : undefined,
                                    minWidth: "34px",
                                    outline: showDescriptions
                                        ? undefined
                                        : "rgb(124, 190, 123) 1px solid",
                                }}
                            />
                        </div>
                    )}
                    {pathname === "/settings" && (
                        <div style={{ padding: "0 2px" }}>
                            <EditModeToggle />
                        </div>
                    )}
                    {pathname === "/quotes" && (
                        <VirtButton
                            onClick={() =>
                                dispatch(
                                    sendTickerCommand({
                                        ticker_name: "",
                                        command: "VTS",
                                    }),
                                )
                            }
                        >
                            <div style={{ marginBottom: "-17px" }}>A</div>
                            <div style={{ marginBottom: "-17px" }}>L</div>
                            <div>L</div>

                            <div style={{ marginBottom: "-17px" }}>V</div>
                            <div style={{ marginBottom: "-17px" }}>I</div>
                            <div style={{ marginBottom: "-17px" }}>R</div>
                            <div style={{ marginBottom: "-17px" }}>T</div>
                        </VirtButton>
                    )}
                    {pathname === "/quotes" && <MassCommandsDropdown />}
                </RightIcons>
                <LogsWebSocket />
                <NotificationModal
                    isOpen={isNotificationModalOpen}
                    onRequestClose={closeNotificationModal}
                />
            </RightWrapper>
        </>
    );
};

export default RightSideMenu;
